<template>
  <div class="app-container">
    <el-tabs type="border-card" v-model="activeName" v-tab-change:activeName="setActiveName">
      <!-- 图片检测 -->
      <el-tab-pane label="图片检测" name="0">
        <security :type="0"></security>
      </el-tab-pane>

      <!-- 视频检测 -->
      <el-tab-pane label="视频检测" name="1">
        <security :type="1"></security>
      </el-tab-pane>

      <!-- 文本检测 -->
      <el-tab-pane label="文本检测" name="2">
        <security :type="2"></security>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import security from "@/views/systemManagement/contentSecurity/contentSecurity";

export default {
  components: {
    security
  },
  data() {
    return {
      activeName: "0"
    }
  }
};
</script>

<style scoped lang="scss">

</style>
